"use strict";

define('rs/form/formobjects/comments.controller',['vertebrae', 'rs/models/comment', 'rs/form/formobjects/comments.view', 'rs/helper'], function (Vertebrae, Comment, CommentsView, helper) {
  var CommentsController = Vertebrae.Controller.extend({
    properties: ['comments', 'commentMap', 'documentModel', 'filtered', 'formObject', 'formController', 'permissions', 'visible'],
    initialize: function initialize(props) {
      this.applyProperties(props);
      this.setCommentMap({});
      this.setComments([]);
      this._super();
    },
    checkPermission: function checkPermission(perm) {
      return this.getFormController().checkPermission(perm);
    },
    refreshFormObjectCommentCount: function refreshFormObjectCommentCount() {
      var permissions = this.getPermissions(),
        comments = this.getComments(),
        filterField = '',
        unread = null;
      if (permissions.canAddressComments) {
        filterField = 'needsAddress';
      } else if (permissions.canResolveComments) {
        filterField = 'needsResolve';
      }
      unread = _.filter(comments, function (c) {
        return c[filterField];
      });
      this.getFormObject().updateCommentCount(comments.length, unread.length);
    },
    canAddComments: function canAddComments() {
      return this.getFormObject().getFormController().canAddComments();
    },
    hasDocumentPermission: function hasDocumentPermission(permission) {
      return this.getPermissions()[permission];
    },
    canReplyToComments: function canReplyToComments() {
      var permissions = this.getPermissions();
      return permissions.canReplyComments;
    },
    canHideComments: function canHideComments() {
      var permissions = this.getPermissions();
      return permissions.canHideComments;
    },
    canViewHiddenComments: function canViewHiddenComments() {
      var permissions = this.getPermissions();
      return permissions.canHideComments || this.checkPermission('EFORMS_VIEW_ALL_COMMENTS');
    },
    canAddressComments: function canAddressComments() {
      var permissions = this.getPermissions();
      return permissions.canAddressComments;
    },
    canResolveComments: function canResolveComments() {
      var permissions = this.getPermissions();
      return permissions.canResolveComments;
    },
    getDocumentId: function getDocumentId() {
      return this.getDocumentModel().getId();
    },
    getId: function getId() {
      return this.getFormObject().getId();
    },
    getUser: function getUser() {
      return this.getFormObject().getFormController().getAppController().getUser();
    },
    loadingForPromise: function loadingForPromise() {
      return this.getFormObject().getFormController().loadingForPromise();
    },
    viewIsReady: function viewIsReady() {
      var view = this.getView(),
        that = this;
      this.deferred = this.requestComments().then(function (comments) {
        that.setComments(_.map(comments || [], that.setupComment, that));
        that.refreshFormObjectCommentCount();
        return comments;
      }).lastly(function () {
        view.render();
        that.switchFilter();
      });
    },
    switchFilter: function switchFilter() {
      var filtered = this.getFiltered(),
        view = this.getView(),
        permissions = this.getPermissions(),
        canFilter = this.canAddressComments() || this.canResolveComments(),
        comments = this.getComments(),
        i = 0,
        len = comments.length,
        hiddenCount = 0,
        filteredText = filtered == null || filtered ? this.canAddressComments() ? 'unaddressed' : 'unresolved' : 'all';
      if (canFilter) {
        view.setFilterText('show ' + filteredText);
      }
      if (filtered == null) {
        this.setFiltered(false);
        return;
      }
      if (filtered) {
        this.setFiltered(false);
        view.showAllComments();
        view.refreshCommentListOrder();
        view.hideEmptyMessage();
      } else {
        this.setFiltered(true);
        for (i = 0; i < len; ++i) {
          if (this.isCommentResolved(comments[i]) || comments[i].hidden || !comments[i].finalizedDate) {
            hiddenCount++;
            view.hideCommentById(comments[i].id);
          }
        }
        view.refreshCommentListOrder();
      }
      if (hiddenCount == len) {
        view.showEmptyMessage();
      } else {
        view.hideEmptyMessage();
      }
    },
    isCommentResolved: function isCommentResolved(comment) {
      return comment.complete;
    },
    refreshCommentFilter: function refreshCommentFilter(comment) {
      var filtered = this.getFiltered(),
        view = this.getView(),
        canFilter = this.canResolveComments() || this.canAddressComments();
      if (filtered) {
        if (this.isCommentResolved(comment) || !comment.finalizedDate || comment.hidden) {
          view.hideCommentById(comment.id);
        } else {
          view.hideEmptyMessage();
        }
      }
    },
    setupComment: function setupComment(comment) {
      var commentMap = this.getCommentMap(),
        user = this.getUser();
      comment.currentUserCreated = user.getPersonId() === comment.createPersonId;
      comment.canEdit = comment.currentUserCreated && !comment.finalizedDate;
      comment.canDelete = false;
      comment.canHide = this.canHideComments();
      comment.canReply = this.canReplyToComments();
      comment.canResolve = this.canResolveComments();
      comment.needsResolve = comment.canResolve && comment.addressed && !comment.resolved && !comment.hidden;
      comment.canAddress = this.canAddressComments() && comment.finalizedDate && !comment.resolved;
      comment.needsAddress = comment.canAddress && comment.finalizedDate && !comment.addressed;
      comment.needsFeedback = comment.canResolve && !comment.addressed && !comment.resolved && !comment.hidden;
      comment.addressedPersonDisplay = comment.addressedPersonId === user.getPersonId() ? 'you' : comment.displayAddressedPerson;
      comment.resolvedPersonDisplay = comment.resolvedPersonId === user.getPersonId() ? 'you' : comment.displayResolvedPerson;
      comment.replies = _.map(comment.replies, this.setupComment, this);
      commentMap[comment.id] = comment;
      return comment;
    },
    didAddNewComment: function didAddNewComment(comment) {
      var comments = this.getComments(),
        index = 0,
        context = null;
      comment.permissions = this.getPermissions();
      comments.push(comment);
      this.getView().refreshCommentList();
      this.refreshFormObjectCommentCount();
    },
    addCommentDidFail: function addCommentDidFail(err) {},
    setupView: function setupView() {
      this.setView(new CommentsView());
    },
    getViewProperties: function getViewProperties() {
      var comments = this.getComments();
      return {
        comments: comments,
        canAdd: this.canAddComments(),
        canHide: this.canHideComments(),
        canResolve: this.canResolveComments(),
        canAddress: this.canAddressComments()
      };
    },
    requestComments: function requestComments() {
      return this.getDocumentModel().requestComments(this.getId(), this.getPermissions());
    },
    requestCommentEditAtIndex: function requestCommentEditAtIndex(index, text) {
      var comment = this.getComments()[index];
      return comment.requestEdit(text).lastly(this.loadingForPromise());
    },
    requestCommentEditAtId: function requestCommentEditAtId(id, text) {
      var comment = this.getCommentMap()[id];
      return comment.requestEdit(text).lastly(this.loadingForPromise());
    },
    requestDeleteCommentAtIndex: function requestDeleteCommentAtIndex(index) {
      var comments = this.getComments(),
        comment = comments[index];
      return comment.requestDelete().bind(this).tap(function () {
        comments.splice(index, 1);
        this.refreshFormObjectCommentCount();
      })["finally"](this.loadingForPromise());
    },
    requestDeleteReplyCommentAtIndex: function requestDeleteReplyCommentAtIndex(commentIndex, replyIndex) {
      var comment = this.getComments()[commentIndex],
        reply = comment.replies[replyIndex];
      return reply.requestDelete().bind(this).tap(function () {
        comment.replies.splice(replyIndex, 1);
        this.refreshFormObjectCommentCount();
      })["finally"](this.loadingForPromise());
    },
    requestResolveCommentToggleAtIndex: function requestResolveCommentToggleAtIndex(index) {
      var comment = this.getComments()[index];
      return comment.requestResolve(!comment.getResolved()).bind(this).thenReturn(comment).then(this.setupComment).then(this.refreshFormObjectCommentCount).tap(function () {
        return this.getFormController().refreshComments();
      }).lastly(this.loadingForPromise());
    },
    requestAddressCommentToggleAtIndex: function requestAddressCommentToggleAtIndex(index) {
      var comment = this.getComments()[index];
      return comment.requestAddress(!comment.getAddressed()).bind(this).thenReturn(comment).then(this.setupComment).then(this.refreshFormObjectCommentCount).tap(function () {
        return this.getFormController().refreshComments();
      }).lastly(this.loadingForPromise());
    },
    requestToggleHideCommentAtId: function requestToggleHideCommentAtId(id) {
      var comment = this.getCommentMap()[id];
      return Promise.bind(this).then(function () {
        if (comment.getHidden()) {
          return comment.requestUnhide();
        } else {
          return comment.requestHide();
        }
      }).thenReturn(comment).then(this.setupComment).lastly(this.loadingForPromise());
    },
    requestCommentReply: function requestCommentReply(index, text) {
      var comment = this.getComments()[index],
        that = this;
      return comment.requestReply(text).bind(this).lastly(this.loadingForPromise()).then(this.setupComment);
    },
    getReplyCountAtCommentIndex: function getReplyCountAtCommentIndex(index) {
      var comment = this.getComments()[index];
      return comment ? comment.getReplies().length : 0;
    },
    addComment: function addComment(text, id) {
      var promise = null;
      return this.getDocumentModel().requestCommentAdd(this.getId(), text).bind(this).then(this.setupComment).then(this.didAddNewComment, this.addCommentDidFail.proxy(this)).lastly(this.loadingForPromise());
      return promise;
    },
    toggle: function toggle() {
      this.visible = !this.visible;
      return this.getView().toggle();
    }
  });
  return CommentsController;
});

